<template>
  <a-button class="code-btn" @click="codeBtnClick" ghost type="primary" :disabled="disabled">
    {{ realMsg }}
  </a-button>
</template>

<script>
import { NGET as Get } from '@/utils/net-work.ts'

const TIMEOUT_SECONDS = 60
let timeback = null
export default {
  // 忘记密码、注册获取短信验证码
  name: 'CodeCountBtn',
  props: {
    clean: {
      type: Boolean,
      default: true
    },
    // 手机号
    phone: {
      type: String,
      default: ''
    },
    // 注册或重置，默认注册
    action: {
      type: String,
      default: 'register'
    },
    // 是否验证图形验证码
    hasImgCode: {
      type: Boolean,
      default: false
    },
    // 按钮展示文字
    msg: {
      type: String,
      default: '发送验证码'
    }
  },
  data() {
    return {
      // 等待时间
      wait: TIMEOUT_SECONDS,
      // 按钮可点击
      disabled: false,
      // 按钮展示文字
      realMsg: this.msg
    }
  },
  watch: {
    clean(val) {
      if (!val) {
        this.disabled = false
        this.realMsg = this.msg
        this.wait = TIMEOUT_SECONDS
        clearTimeout(this.timeback)
      }
    }
  },
  methods: {
    // 获取手机验证码
    async codeBtnClick() {
      setTimeout(() => {
        // 发送验证码点击埋点
        window['sensors'].track('SendMessage_buttonClick', {
          buttonName: this.msg,
          position: this.$route.meta.title || '未知'
        })
      }, 200)
      // 验证手机号
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$emit('error', 'tel_error', '请输入11位手机号码')
        return
      }
      // 需要校验图形验证码
      if (this.hasImgCode && !(await this.$parent.imgCodeValid())) {
        this.$emit('error', 'code_error', '请输入正确的图形验证码')
        return
      }
      // 校验通过后发送短信
      try {
        let res = await Get('/api/auth/verification-code', {
          phone: this.phone,
          action: this.action
        })
        // 发送失败
        if (!res.success) {
          this.$message.error(res.error)
          // 需要更新图形验证码
          this.hasImgCode && this.$emit('getNewImageCode')
          return
        }
        // 发送成功，发送通知
        this.$emit('success')
        this.$message.success('短信发送成功')
        this.time()
      } catch (err) {
        // 需要更新图形验证码
        this.hasImgCode && this.$emit('getNewImageCode')
      }
    },
    time() {
      if (this.wait === 1) {
        this.wait = TIMEOUT_SECONDS
        this.disabled = false
        this.realMsg = this.msg
      } else {
        if (!this.clean) {
          clearTimeout(this.timeback)
        } else {
          this.wait--
          this.disabled = true
          this.realMsg = this.wait + 'S'
          timeback = setTimeout(() => this.time(), 1000)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.ant-btn-background-ghost.ant-btn-primary {
  color: #386bff;
  border-color: #386bff;
}
</style>
